import { css } from '@emotion/react';
import { Button, Col, colors, Content, Row, Title } from 'common-components';
import { Space } from 'antd';
import { useAppTranslation } from '@hooks';

// TODO remove this
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Header = function ({ data }) {
  const { translate } = useAppTranslation();
  const texts = [
    {
      type: 'tablePageTitle',
      content: translate('contributions.title'),
    },
  ];

  return (
    // @ts-ignore
    <Content>
      <Row
        justify={'space-between'}
        align={'top'}
        css={css`
          margin: 16px 0 0;
        `}
      >
        <Col>
          <Row justify={'space-between'} gutter={30} align={'middle'}>
            <Col>
              {texts.map((text, index) => {
                if (index === 0) {
                  return (
                    <Space key={`title-${text.content}-${index}`} align={'center'}>
                      <Title style={{ fontSize: 18, lineHeight: '28px', color: colors.black }}>
                        {text.content}
                      </Title>
                    </Space>
                  );
                }
                return (
                  <Title key={`title-${text.content}-${index}`} preset={text.type as any}>
                    {text.content}
                  </Title>
                );
              })}
            </Col>
          </Row>
        </Col>
        <Col>
          {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
          <Button iconLeft="FilterLines" onClick={() => {}}>
            {translate('common.filter')}
          </Button>
        </Col>
      </Row>
    </Content>
  );
};

export default Header;
